

import templatePostModal from '@/app-template/lib/components/PostModal.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PostModal',
  components: { templatePostModal },
});
